export default "__VITE_ASSET__850c6389__"